import request from '../../utils/request'
const urlParams = process.env.VUE_APP_UPLOAD_REAL_PATH
export default {
  // 获取租户列表
  tenantList(data) {
    const params = data
    return request({
      url: urlParams + '/tenant/list',
      type: 'get',
      params: params
    })
  },  
  // 租户新增修改
  tenantUpdata(data) {
    const params = data
    return request({
      url: urlParams + '/tenant/addOrUpd',
      type: 'post',
      params: params
    })
  },  
  // 修改租户状态
  tenantStatus(data) {
    const params = data
    return request({
      url: urlParams + '/tenant/updStatus',
      type: 'post',
      params: params
    })
  },   
  // 修改租户状态
  tenantReset(data) {
    const params = data
    return request({
      url: urlParams + '/tenant/reset',
      type: 'post',
      params: params
    })
  },   
}